import {
  DHL_ECOMMERCE,
  FEDEX,
  NEWGISTICS,
  SHIPPO,
} from '../../../common/constants/ShipperNames.js'
import {updateLabelConfig} from '../../../data/labelInfos/index.js'
import ConfigSelect from './ConfigSelect.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
  defaultValidLabelPropertiesFunc,
} from './useLabelProperty.js'

const VALID_SHIPPER_TYPES = [DHL_ECOMMERCE, FEDEX, NEWGISTICS, SHIPPO]

export function dangerousGoodsTemplate(shipperType) {
  return `${shipperType}__${
    shipperType === FEDEX ? 'dangerous_goods_option' : 'dangerous_goods'
  }`
}

function labelPropertiesFunc(shipperType) {
  return VALID_SHIPPER_TYPES.includes(shipperType)
    ? [dangerousGoodsTemplate(shipperType)]
    : []
}

export default function DangerousGoods() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = DangerousGoods.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigSelect
      label="Dangerous Goods"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: value,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      shipperOptionsProperty="dangerous_goods"
    />
  )
}

DangerousGoods.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
